<template>
    <strong>
        {{ label }}
        <span
            v-if="required"
            class="red--text"
        >
                *
            </span>
    </strong>
</template>

<script>
export default {
    props: {
        label: String,
        required: Boolean,
    }
}
</script>

<style scoped>

</style>